module.exports = __webpack_public_path__ + "img/studio.897b2dcc.svg";